import script from "./amazon-bind-modal.vue?vue&type=script&lang=ts&setup=true"
export * from "./amazon-bind-modal.vue?vue&type=script&lang=ts&setup=true"

import "./amazon-bind-modal.vue?vue&type=style&index=0&id=3fdd0263&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fdd0263"]])

export default __exports__